import React, { Suspense } from 'react';
import Card, { CardBody } from '../../components/bootstrap/Card';
import Page from '../Page/Page';
import WebsiteRoutes from './WebsiteRoutes';

/*
 * Plain markup instead of PageWrapper on purpose: PageWrapper renders <Seo>,
 * and a transient Suspense fallback must not write head tags — its default
 * (English) canonical/hreflang can leak into the prerender snapshot of the
 * page that eventually mounts.
 */
const LOADING = (
	<div className='page-wrapper container-fluid'>
		<Page>
			<div className='row h-100'>
				<div className='col-lg-6'>
					<Card stretch>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
				<div className='col-lg-6'>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
			</div>
		</Page>
	</div>
);

const Content = () => {
	return (
		<main className='content'>
			<Suspense fallback={LOADING}>
				<WebsiteRoutes />
			</Suspense>
		</main>
	);
};

export default Content;
